import {
  BarChart3,
  Building2,
  ClipboardList,
  KeyRound,
  LogOut,
  Menu,
  UsersRound,
  X,
} from "lucide-react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useState } from "react";

import { useAuth } from "@/components/AuthProvider";
import { api } from "@/lib/api";


const navigationItems = [
  { to: "/dashboard", label: "Dashboard", icon: BarChart3, testId: "navigation-dashboard" },
  { to: "/stores", label: "Toko", icon: Building2, testId: "navigation-stores" },
  { to: "/reports", label: "Laporan", icon: ClipboardList, testId: "navigation-reports" },
];

export const AppShell = () => {
  const { setUser, user } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user.role === "ADMIN";
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setUser(false);
      navigate("/login");
    }
  };

  const items = [
    ...navigationItems,
    ...(isAdmin ? [
      { to: "/managers", label: "Manager", icon: UsersRound, testId: "navigation-managers" },
      { to: "/audit", label: "Audit log", icon: ClipboardList, testId: "navigation-audit" },
    ] : []),
    { to: "/account", label: "Password", icon: KeyRound, testId: "navigation-password" },
  ];

  return (
    <div className="app-frame" data-testid="authenticated-app-shell">
      <button
        aria-label="Tutup menu"
        className={`mobile-menu-overlay ${isSidebarOpen ? "is-visible" : ""}`}
        data-testid="mobile-menu-overlay"
        onClick={() => setIsSidebarOpen(false)}
        type="button"
      />
      <aside
        className={`app-sidebar ${isSidebarOpen ? "is-open" : ""}`}
        data-testid="application-navigation"
      >
        <div className="app-brand" data-testid="application-brand">
          <span>ANEKA</span>
          <strong>Control Desk</strong>
        </div>
        <nav className="nav-list" aria-label="Navigasi aplikasi">
          {items.map(({ to, label, icon: Icon, testId }) => (
            <NavLink
              className={({ isActive }) => `nav-link ${isActive ? "is-active" : ""}`}
              data-testid={testId}
              key={to}
              onClick={() => setIsSidebarOpen(false)}
              to={to}
            >
              <Icon aria-hidden="true" size={17} />
              {label}
            </NavLink>
          ))}
        </nav>
        <button
          className="logout-button"
          data-testid="logout-button"
          onClick={handleLogout}
          type="button"
        >
          <LogOut aria-hidden="true" size={17} />
          Keluar
        </button>
      </aside>
      <section className="app-main">
        <header className="user-strip" data-testid="current-user-summary">
          <button
            aria-label="Buka menu"
            className="mobile-menu-button"
            data-testid="mobile-menu-toggle"
            onClick={() => setIsSidebarOpen((current) => !current)}
            type="button"
          >
            {isSidebarOpen ? (
              <X aria-hidden="true" size={19} />
            ) : (
              <Menu aria-hidden="true" size={19} />
            )}
          </button>
          <span className="mobile-strip-brand" data-testid="mobile-strip-brand">ANEKA / POS</span>
          <span
            className={`role-chip role-${user.role.toLowerCase()}`}
            data-testid="current-user-role"
          >
            {user.role}
          </span>
          <span className="current-user-email" data-testid="current-user-email">{user.email}</span>
        </header>
        <Outlet />
      </section>
    </div>
  );
};